<template lang="pug">
  dv-form(
    v-model="formData"
    :schema="schema"
    :nestable="false"
    v-slot="{ fields }"
  )
    v-row
      v-col(cols="6")
        dv-form-field(
          :field="fields.score"
        )
    v-row
      v-col(cols="12")
        dv-form-field(
          :field="fields.options"
        )
</template>

<script>
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import DvNumberField from '@/packages/ui/components/inputs/DvNumberField.vue';
import PairMatchOptionField from '../inputs/PairMatchOptionField.vue';

import OptionsList from '../lists/OptionsList.vue';

export default {
  components: {
    DvForm,
    DvFormField,
    DvNumberField,
    OptionsList,
  },
  props: {
    value: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  computed: {
    schema() {
      const { score } = this.formData;

      return [
        {
          name: 'score',
          value: 'score',
          label: 'Баллов за ответ',
          rules: 'required',
          component: DvNumberField,
          props: {
            min: 1,
            max: 999,
          },
        },
        {
          name: 'options',
          value: 'options',
          component: OptionsList,
          props: {
            component: PairMatchOptionField,
            createText: 'Добавить пару',
            score,
          },
        },
      ];
    },
  },
  watch: {
    value: {
      handler(val) {
        this.formData.options = val;
        this.formData.score = this.formData?.options?.at(0)?.score;
      },
      immediate: true,
    },
    'formData.options': {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
